// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__header__root","title":"cmp-Minicart__header__title"};